// vue
import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';

export const usePostgisService = () => {
    const store = useStore();
    const { apiUrl } = store.state;
    const axios = useAxios();

    // methods
    const getGeometryArea = async (geometryAreaData: any): Promise<any> => {
        const res = await axios.post(
            `${apiUrl}/temp-postgis/geometry-area`,
            geometryAreaData,
        );

        return res.data;
    };

    const getPointsDistance = async (pointsDistanceData: any): Promise<any> => {
        const res = await axios.post(
            `${apiUrl}/postgis/distance`,
            pointsDistanceData,
        );

        return res.data;
    };

    const getLayerGeometry = async (courseSchemaId: any): Promise<any> => {
        const res = await axios.get(
            `${apiUrl}/mapbox/layer/geometry/${courseSchemaId}`,
        );

        return res.data;
    };

    return {
        getPointsDistance,
        getGeometryArea,
        getLayerGeometry,
    };
};
